import {createContext} from 'react'

function noop() {}

export const AuthContext = createContext({
  token: null,
  userId: null,
  login: noop,
  logout: noop,
  userType: "guest",
  nsi: [],
  isAuthenticated: false,
  user: null
})
